import * as React from 'react'

const SvgInformationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.625 13.75V8.125h-2.5v1.25h1.25v4.375H7.5V15h5v-1.25h-1.875zM10 4.375a.937.937 0 100 1.875.937.937 0 000-1.875zm0 14.375a8.75 8.75 0 110-17.5 8.75 8.75 0 010 17.5zM10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15z"
      fill="#163250"
    />
  </svg>
)

export default SvgInformationIcon
